<template>
  <component :is="fieldLayoutComponent" ref="field" :content="content" :show-get-help="showRequestHelpPrompt">
    <text-input ref="input" :input-name="field" :value="value" :validation-errors="validationErrors"
                :placeholder="placeholderText" @changed="updateFieldValue" />
  </component>
</template>

<script>
import FieldLayout from './field-layout'
import FieldMixin from './field-mixin'
import TextInput from '../components/inputs/text-input'

export default {
  components: { TextInput },

  mixins: [ FieldMixin ],

  props: {
    fieldLayoutComponent: {
      type: Object,
      required: false,
      default() { return FieldLayout}
    },
    placeholderText: {
      type: String,
      required: false
    }
  },

  methods: {
    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>
